import api from "@/api";

const state = {
    list: [],
};

const getters = {};

const actions = {
    create({ dispatch }, { payload }) {
        return api
            .post(`/api/surveys/${payload.survey}/action-items/comments`, payload)
            .then(() => {
                return dispatch(
                    "surveys/actionItem/get",
                    { payload: { _id: payload.actionItem } },
                    { root: true },
                );
            });
    },
    delete(
        { dispatch },
        {
            payload: {
                survey,
                actionItem,
                comment: { _id },
            },
        },
    ) {
        return api
            .delete(`/api/surveys/${survey}/action-items/${actionItem._id}/comment/${_id}`)
            .then(() => {
                return dispatch(
                    "surveys/actionItem/get",
                    { payload: { _id: actionItem._id } },
                    { root: true },
                ); // reload action item.
            });
    },
};

const mutations = {};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
